export default {
  item: 0,
  __typename: 'Cart'
};
